import { environment } from "./environment";

export const appsyncConfig = {
  httpEndpoint: environment.appsyncHttpEndpoint,
  realtimeEndpoint: environment.appsyncRealtimeEndpoint,
  apiId: environment.appsyncApiId,
  region: environment.appsyncRegion,
  customDomainUrl: environment.appsyncCustomDomainUrl,
};

// Amplify configuration for AppSync
// Note: For userPool auth mode, Amplify automatically uses the Cognito User Pool
// configured in the Auth section, but we should ensure the User Pool ID matches
// what AppSync expects
export const amplifyAppSyncConfig = {
  GraphQL: {
    endpoint: environment.appsyncHttpEndpoint,
    region: environment.appsyncRegion,
    defaultAuthMode: "userPool" as const,
    // The User Pool configuration comes from the Auth.Cognito section in amplify.ts
    // AppSync will use the same User Pool configured in Auth
  },
};
